

import HomePage from "@/pages/HomePage.vue"
import DashboardPage from "@/pages/DashboardPage.vue"
import LoginForm from "@/components/LoginForm.vue"
// eslint-disable-next-line no-unused-vars
import DashboardMain from "@/components/Dashboard/DashboardMain.vue"
import RegisterComponent from "@/components/RegisterComponent.vue"
import { checkTokenIfActive } from "./services/UserService"

import { createRouter, createWebHistory } from "vue-router";

const auth = async (to, from, next) => {
    const response = await checkTokenIfActive();
  
  
    if (response != true) {
      next('/');
    } else {
      next();
    }
  };

const routes = [
    {
        path: '/', name: 'home', component: HomePage
        
    
    },
    {
        path: '/dashboard', name: 'dashboard', component: DashboardPage, beforeEnter: auth,  children: [
            {
                path:'/dashboard',
                component: DashboardMain
            }
        ]
    },
    {
        path: '/login', name: 'login', beforeEnter: !auth, component: LoginForm
    },
    {
        path: '/register', name: 'register', component: RegisterComponent
    },




]


const router = createRouter({

    history: createWebHistory(),
    routes, 
  })
  

export default router; 
